(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sh-taste-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const main = document.querySelector('main.main');
  if (!main || !document.querySelector('[data-sh-taste-runtime]')) return;
  const norm = value => String(value || '').normalize('NFC').replace(/\s+/g, ' ').trim();
  const initializedDefaults = new WeakSet();
  const initializeBundleDefaults = () => {
    main.querySelectorAll('[data-sh-taste-default="desktop"]').forEach(content => {
      const button = content.closest('.accordion__item')?.querySelector('.item__button');
      if (!button || initializedDefaults.has(button)) return;
      initializedDefaults.add(button);
      if (matchMedia('(min-width:834px)').matches && button.getAttribute('aria-expanded') === 'false') button.click();
    });
  };
  // The legacy product component has no after-actions slot; move the native accordion intact.
  const placeCocktailProfile = () => {
    main.querySelectorAll('.accordion[data-sh-taste-after-cart]').forEach(accordion => {
      const details = accordion.closest('.product__details');
      const actions = details?.querySelector(':scope > .product__actions');
      if (actions && actions.nextElementSibling !== accordion) actions.after(accordion);
    });
  };
  const syncBundles = () => {
    main.querySelectorAll('[data-sh-bundles]').forEach(root => {
      const form = root.closest('.product-form');
      if (!form) return;
      const title = norm(form.querySelector('.product__options .property--active .property__value')?.textContent);
      const panels = [...root.querySelectorAll('[data-sh-variant]')];
      const selected = title ? panels.find(panel => norm(panel.dataset.shVariantTitle) === title) : panels[0];
      panels.forEach(panel => {
        const hidden = panel !== selected;
        if (panel.hidden !== hidden) panel.hidden = hidden;
      });
    });
  };
  let scheduled = false;
  let scanCatalog = () => {};
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {scheduled = false;placeCocktailProfile();initializeBundleDefaults();syncBundles();scanCatalog();});
  };
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || record.target.matches?.('.property'))) schedule();
  }).observe(main, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  document.addEventListener('setVariant', schedule);
  document.addEventListener('shopify:section:load', schedule);
  const dataRoot = document.querySelector('[data-sh-catalog-data]');
  if (dataRoot) {
    const desktop = matchMedia('(min-width:834px) and (hover:hover) and (pointer:fine)');
    const sheet = document.querySelector('#sh-taste-sheet');
    const triggerTemplate = document.querySelector('template[data-sh-taste-trigger]');
    const canOpenSheet = sheet && typeof sheet.showModal === 'function';
    let sheetTrigger = null;
    let scrollLock = null;
    if (canOpenSheet) {
      sheet.querySelector('.sh-taste-sheet__close').addEventListener('click',() => sheet.close());
      let backdropStart = false;
      const outsideSheet = event => {
        const r = sheet.getBoundingClientRect();
        return event.target === sheet && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom);
      };
      sheet.addEventListener('pointerdown',event => { backdropStart = outsideSheet(event); });
      sheet.addEventListener('click',event => { if (backdropStart && outsideSheet(event)) sheet.close(); });
      sheet.addEventListener('close',() => {
        if (scrollLock) {
          for (const [key,value] of Object.entries(scrollLock.styles)) document.body.style[key] = value;
          window.scrollTo({left:scrollLock.x,top:scrollLock.y,behavior:'instant'});
          scrollLock = null;
        }
        if (sheetTrigger?.isConnected && (!desktop.matches || sheetTrigger.closest('.build-box-item'))) sheetTrigger.focus({preventScroll:true});
        sheetTrigger = null;
      });
    }
    const profiles = new Map();
    const identities = new Map();
    const ambiguous = new Set();
    const visited = new Set();
    let next = '';
    let fetching = false;
    const readData = root => {
      root.querySelectorAll('template[data-sh-catalog-profile]').forEach(template => {
        const title = norm(template.dataset.productTitle);
        const id = template.dataset.productId;
        if (ambiguous.has(title)) return;
        if (identities.has(title) && identities.get(title) !== id) { ambiguous.add(title);profiles.set(title,null);return; }
        identities.set(title,id);
        profiles.set(title,template);
      });
      next = root.dataset.shNext || '';
    };
    readData(dataRoot);
    const loadNext = async () => {
      if (!next || fetching) return;
      fetching = true;
      try {
        const url = new URL(next,location.origin);
        if (url.origin !== location.origin) { next = '';return; }
        url.searchParams.set('view','sh-taste');
        if (visited.has(url.href)) { next = '';return; }
        visited.add(url.href);
        const response = await fetch(url,{credentials:'same-origin',signal:AbortSignal.timeout(8000)});
        if (!response.ok) throw new Error('Profile data unavailable');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const root = doc.querySelector('[data-sh-catalog-data]');
        if (!root) throw new Error('Profile data missing');
        readData(root);
      } catch { next = ''; }
      finally { fetching = false;schedule(); }
    };
    const cardTitle = card => norm(card?.querySelector('.product__title, .build-a-box-body > .title')?.textContent);
    scanCatalog = () => {
      main.querySelectorAll('.collection .product-card, .search .product-card, .build-a-box #items-list .build-box-item').forEach(card => {
        const title = cardTitle(card);
        const existing = card.querySelector('.sh-taste--catalog');
        if (!ambiguous.has(title) && existing?.dataset.shTitle === title && existing.dataset.shTasteProduct === identities.get(title)) return;
        existing?.remove();
        card.querySelector('.sh-taste-info')?.remove();
        card.classList.remove('sh-taste-card-ready');
        const template = profiles.get(title);
        const isBuilder = card.classList.contains('build-box-item');
        const host = isBuilder ? card : card.querySelector('.card__media');
        if (!template || !host || /^(IMG|VIDEO|PICTURE)$/.test(host.tagName)) return;
        const profile = template.content.firstElementChild?.cloneNode(true);
        if (!profile) return;
        profile.classList.add('sh-taste--catalog');
        profile.dataset.shTitle = title;
        host.classList.add('sh-taste-hover-host');
        host.append(profile);
        card.classList.add('sh-taste-card-ready');
        if (canOpenSheet && triggerTemplate) {
          const button = triggerTemplate.content.firstElementChild.cloneNode(true);
          button.setAttribute('aria-label',button.getAttribute('aria-label') + ': ' + title);
          card.append(button);
        }
      });
      if (next) loadNext();
    };
    main.addEventListener('click',event => {
      const button = event.target.closest('.sh-taste-info');
      if (!button || !canOpenSheet) return;
      const card = button.closest('.sh-taste-card-ready');
      const isBuilder = card?.classList.contains('build-box-item');
      if (desktop.matches && !isBuilder) return;
      const title = cardTitle(card);
      const template = profiles.get(title);
      if (!template || sheet.open) return;
      event.preventDefault();
      event.stopPropagation();
      const profile = template.content.firstElementChild.cloneNode(true);
      profile.querySelector('.sh-taste__title')?.remove();
      sheet.querySelector('#sh-taste-sheet-product').textContent = title;
      sheet.querySelector('.sh-taste-sheet__content').replaceChildren(profile);
      sheet.classList.toggle('sh-taste-sheet--builder',Boolean(isBuilder));
      sheetTrigger = button;
      scrollLock = {x:window.scrollX,y:window.scrollY,styles:{}};
      for (const key of ['position','top','left','width','overflow']) scrollLock.styles[key] = document.body.style[key];
      Object.assign(document.body.style,{position:'fixed',top:`-${scrollLock.y}px`,left:`-${scrollLock.x}px`,width:'100%',overflow:'hidden'});
      sheet.showModal();
    },true);
    desktop.addEventListener('change',() => { if (desktop.matches && sheet?.open && !sheetTrigger?.closest('.build-box-item')) sheet.close();schedule(); });
    const setKeyboardMode = enabled => {
      if (main.hasAttribute('data-sh-taste-keyboard') !== enabled) main.toggleAttribute('data-sh-taste-keyboard',enabled);
    };
    document.addEventListener('pointermove',() => setKeyboardMode(false),{passive:true});
    document.addEventListener('pointerdown',() => setKeyboardMode(false),{passive:true});
    document.addEventListener('keydown',event => {
      if (event.key === 'Tab') setKeyboardMode(true);
      if (event.key === 'Escape') event.target.closest('.sh-taste-card-ready')?.setAttribute('data-sh-dismissed','');
    });
    main.addEventListener('pointerover',event => {
      const card = event.target.closest('.sh-taste-card-ready');
      if (card && !card.contains(event.relatedTarget)) card.removeAttribute('data-sh-dismissed');
    });
    main.addEventListener('focusin',event => {
      if (main.hasAttribute('data-sh-taste-keyboard')) event.target.closest('.sh-taste-card-ready')?.removeAttribute('data-sh-dismissed');
    });
  }
  schedule();
})();
  } catch(e) { console.error(e); }
})();

})();
